module.exports = "/_next/static/images/all-access-unlocked-02330b66aa89b6d0702cc5cb3af6e303.png";